export default "__VITE_ASSET__483b70fb__"